import React, { useState } from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";
import { ElectricityAgreementsService } from '../ElectricityAgreements.service';

interface CancelElectricityAgreementConfirmModalProps {
    agreementId: number;
    isOffer: boolean
    handleConfirmSubmit: () => void;
    handleConfirmReject: () => void;
}

export function CancelElectricityAgreementConfirmModal(props: CancelElectricityAgreementConfirmModalProps) {
    const [isLoading, setIsLoading] = useState(false);

    const confirmSubmit = async () => {
        setIsLoading(true);
        
        try {
            await ElectricityAgreementsService.cancelElectricityAgreement(props.agreementId);
            
            setTimeout(() => {
                setIsLoading(false);
                props.handleConfirmSubmit();
            }, 100);
        } catch(e) {
            console.error(e)
            setIsLoading(false);
        }
    };

    const rejectSubmit = () => {
        props.handleConfirmReject();
    };

    return (
        <>
            <Modal
                show={true}
                size={"sm"}
                centered
                onHide={props.handleConfirmReject}
            >
                <Modal.Header>
                    <Modal.Title>
                        Kinnita muudatused
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        {
                            props.isOffer ? (
                                <span>{`Kas oled kindel, et soovid Elektrilepingu pakkumise tühistada?`}</span>
                            ) : (
                                <span>Olen kindel, et kliendi soov on lepingust taganeda ja tühistan lepingu enne lepingu algust</span>
                            )
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                    <Button variant="info"
                            onClick={() => rejectSubmit()}
                            type="button"
                            className={"d-flex align-items-center"}>
                        <span className='px-2'>Ei</span>
                    </Button>
                    <Button variant="primary"
                            onClick={confirmSubmit}
                            type="button"
                            className="d-flex align-items-center">
                        {
                            isLoading ? (
                                <Spinner animation="border" size="sm"/>
                            ) : <span className='px-2'>Jah</span>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
